export const ShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16821_43072)">
        <path
          d="M18.7141 5.00055H14.1426M18.7141 5.00055L11.8569 11.8577M18.7141 5.00055V9.57198"
          stroke="#565656"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7143 12.6196V17.191C18.7143 17.5952 18.5537 17.9828 18.268 18.2685C17.9822 18.5543 17.5946 18.7148 17.1905 18.7148H6.52381C6.11967 18.7148 5.73208 18.5543 5.44631 18.2685C5.16054 17.9828 5 17.5952 5 17.191V6.52436C5 6.12022 5.16054 5.73263 5.44631 5.44686C5.73208 5.16109 6.11967 5.00055 6.52381 5.00055H11.0952"
          stroke="#565656"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16821_43072">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
